import { ExpandMoreOutlined } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from "@mui/material";
import { ServiceCard } from "./service-card";

export const ServiceAccordion = ({ service }: any) => {
  const merchandisesList = service?.merchandises || service?.merchandise || [];
  const subServicesList = service?.subServices || [];

  const hasContent = subServicesList.length > 0 || merchandisesList.length > 0;

  const totalPrice = [
    ...subServicesList,
    ...merchandisesList,
  ].reduce((acc, current) => acc + (Number(current?.price) || 0), 0);

  const serviceName = service?.name || service?.serviceName;
  const serviceDescription = service?.description || service?.serviceCode;

  const summaryContent = (
    <Box gap={2}>
      <Box display="flex" gap={2}>
        <Typography fontWeight="500 !important" fontSize="16px" color="#101828">{serviceName}</Typography>
        <Typography fontWeight="700 !important" fontSize="16px" color="#104145">
          ${totalPrice.toLocaleString()}
        </Typography>
      </Box>
      {serviceDescription && (
        <Typography color="#6A7282" fontWeight="400 !important" fontSize="14px" mt={0.5} mb={0.5}>
          {serviceDescription}
        </Typography>
      )}
    </Box>
  );

  if (!hasContent) {
    return (
      <Box
        sx={{
          border: "1px solid #E5E7EB",
          borderRadius: "12px",
          mb: "10px",
          px: 2,
          py: 1.5,
        }}
      >
        {summaryContent}
      </Box>
    );
  }

  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: "1px solid #E5E7EB",
        borderRadius: "12px !important",
        overflow: "hidden",
        mb: "10px",
        "&:before": {
          display: "none",
        },

        "&.Mui-expanded": {
          borderRadius: "12px",
          margin: "0 0 10px 0",
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
        {summaryContent}
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0, m: -1 }}>
        <Box sx={{ borderTop: "1px solid #E5E7EB" }} />

        <Box
          sx={{
            backgroundColor: "#F9FAFB",
            px: 3,
            py: 2,
          }}
        >
          {subServicesList?.length > 0 && (
            <>
              <Typography fontWeight="500 !important" fontSize="14px" color="#101828" mb={2}>
                Sub-Services
              </Typography>

              <Grid container spacing={1}>
                {subServicesList.map((sub: any, i: number) => (
                  <Grid item xs={12} key={`sub-${i}`}>
                    <ServiceCard item={sub} />
                  </Grid>
                ))}
              </Grid>
            </>
          )}

          {/* Merchandise */}
          {merchandisesList?.length > 0 && (
            <>
              <Typography fontWeight="500 !important" fontSize="14px" color="#101828" mb={2} mt={2}>
                Merchandise Items
              </Typography>

              <Grid container spacing={1}>
                {merchandisesList.map((item: any, i: number) => (
                  <Grid item xs={12} md={6} key={`merchandise-${i}`}>
                    <ServiceCard item={item} />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};